module.exports = __webpack_public_path__ + "media/src/assets/images/mv-copy-38a7dd69ab229e935657775ed9f9f5ea.png";